import axios from 'axios';
import { config_headers, servicelist, URL_API } from '../Config';

export const P405GetDataList= async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.CtService}p_ct_case_specific_list`), body, authorization )
                .then(res => {
                    resolve(res.data);
                }).catch((error)=> {
                    reject(error);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}

export const P405CreateData= async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.CtService}p_ct_case_specific_update`), body, authorization )
                .then(res => {
                    resolve(res);
                }).catch((error)=> {
                    reject(error);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}


